module.exports = __webpack_public_path__ + "static/media/answer-b-pressed.b4c972d4.png";